import RapidStorCharge from '../../types/Charge';

export interface Charge {
    _id: string;
    chargeDescId: number;
    siteId: number;
    applyAtMoveIn: boolean;
    permanent: boolean;
    prorateAtMoveIn: boolean;
    round: boolean;
    useMileageRate: boolean;
    changeToken: string;
    changedAt: string;
    chargeStart: string;
    cost: number;
    inStock: number;
    minPriceIfPC: number;
    orderPoint: number;
    pcRate: number;
    price: number;
    tax1Rate: number;
    tax2Rate: number;
    deleted: boolean;
    includedMiles: number;
    priceType: number;
    chargeDescription: string;
    locationCode: string;
    chargeCategory: string;
}

export const chargeTransformer = (charge: RapidStorCharge): Charge => {
    return {
        _id: charge._id.toString(),
        chargeDescId: charge.ChargeDescID,
        siteId: charge.SiteID,
        applyAtMoveIn: charge.bApplyAtMoveIn,
        permanent: charge.bPermanent,
        prorateAtMoveIn: charge.bProrateAtMoveIn,
        round: charge.bRound,
        useMileageRate: charge.bUseMileageRate,
        changeToken: charge.changeToken,
        changedAt: charge.changedAt,
        chargeStart: charge.dChgStrt,
        cost: charge.dcCost,
        inStock: charge.dcInStock,
        minPriceIfPC: charge.dcMinPriceIfPC,
        orderPoint: charge.dcOrderPt,
        pcRate: charge.dcPCRate,
        price: charge.dcPrice,
        tax1Rate: charge.dcTax1Rate,
        tax2Rate: charge.dcTax2Rate,
        deleted: charge.deleted,
        includedMiles: charge.iIncludedMiles,
        priceType: charge.iPriceType,
        chargeDescription: charge.sChgDesc,
        locationCode: charge.sLocationCode,
        chargeCategory: charge.sChgCategory,
    };
};
